// The mockup shows the FAQ fully collapsed, while Alpha expands the first item on both paths:
// `blocks/faq.twig` does it in the template itself ("expand first item"), after its class filters
// run, and `blocks/rank-math-faq.js` does it while upgrading the Gutenberg block — so there is no
// PHP/config lever for it. The state is fixed here instead; the `data-faq-collapsed` flag then
// releases the CSS guard that hides the pre-expanded panel until this runs (see
// assets/sass/blocks/faq.scss).
export const collapseFaqItems = (faq) => {
  faq.querySelectorAll('.accordion-collapse.show').forEach((panel) => {
    panel.classList.remove('show')

    const button = faq.querySelector(`[data-bs-target="#${panel.id}"]`)
    if (button) {
      button.classList.add('collapsed')
      button.setAttribute('aria-expanded', 'false')
    }
  })

  faq.setAttribute('data-faq-collapsed', '')
}

// the HP FAQ is rendered server-side, so it is collapsible as soon as the DOM is ready — the
// Gutenberg one only exists after its dynamic chunk ran, and is handled in components/rank-math-faq
const collapseRenderedFaqBlocks = () => {
  document.querySelectorAll('.faq-block').forEach(collapseFaqItems)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', collapseRenderedFaqBlocks)
} else {
  collapseRenderedFaqBlocks()
}
